import { PhoneCall } from "lucide-react";
import { cn } from "@/lib/utils";

export function AttributionBadge({ className }) {
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1 text-[9px] font-semibold px-1.5 py-0.5 rounded-full bg-blue-50 text-blue-600 border border-blue-100",
        className,
      )}
    >
      <PhoneCall className="h-2.5 w-2.5" />
      Via Follow-Up
    </span>
  );
}
